import { render } from "./v-editFaq.vue?vue&type=template&id=4ce3f63e"
import script from "./v-editFaq.vue?vue&type=script&lang=js"
export * from "./v-editFaq.vue?vue&type=script&lang=js"

import "./v-editFaq.vue?vue&type=style&index=0&id=4ce3f63e&lang=css"
script.render = render

export default script